<template>
  <div class="container">
    <van-dialog id="van-dialog" />
    <div class="top">
      <div class="fanhui" v-if="isShowBack">
        <img src="../../../static/images/other-fanhui.png" @click="back" />
      </div>
      <div class="fanhui" v-if="!isShowBack"></div>
      <div class="tab">
        <div v-bind:class="{ select: showType == 1 }" @click="qiehuanmoshi2(1)">
          答题模式
        </div>
        <div v-bind:class="{ select: showType == 2 }" @click="qiehuanmoshi2(2)">
          背题模式
        </div>
      </div>
                    <div v-if="value1" @click="changeXing" style="
              position: fixed;
              right: 35px;
              top:18px;
              width: 30px;
              height: 30px;
              z-index:99;">
        <img v-if="list[currNowPage -1].is_favor===null || list[currNowPage -1].is_favor===0" style="width:100%;height:100%" src="../../../static/images/weixuanzhong.png" alt="">
        <img v-else style="width:100%;height:100%" src="../../../static/images/xuanzhongle.png" alt="">
        </div>
      <div></div>
    </div>
    <Swiper
      @change="swiperChange"
      :options="swiperOption"
      class="swiper-container swiper-containerq"
      ref="mySwiper"
      style="min-height: 6rem; padding-top: 0.5rem"
    >
      <div
        class="swiper-slide"
        v-for="(item, index) in swiperList"
        :key="index"
      >
        <div class="beiti">
          <div class="title">
            <div class="tips">
              <img src="../../../static/images/other-selectbg.png" />
              <div v-if="item.question_type == question_type.danxuan">单选</div>
              <div v-if="item.question_type == question_type.duoxuan">多选</div>
              <div v-if="item.question_type == question_type.panduan">判断</div>
            </div>
            <div class="info">{{ item.num }}.{{ item.title }}</div>
          </div>
          <div
            v-if="item.image_url != ''"
            class="pic"
            @click="bigImg(item.image_url)"
          >
            <img v-bind:src="getImgUrl(item.image_url)" />
          </div>
          <div class="selecttab">
            <div
              class="item"
              v-for="(item2, index2) in item.items"
              :key="index2"
              @click="selectanswer2(item, index2, index)"
            >
              <div v-if="index2 == 0" v-bind:class="item.sel1">A</div>
              <div v-if="index2 == 1" v-bind:class="item.sel2">B</div>
              <div v-if="index2 == 2" v-bind:class="item.sel3">C</div>
              <div v-if="index2 == 3" v-bind:class="item.sel4">D</div>
              <div v-if="index2 == 0" v-bind:class="item.sel1">
                {{ item2.item_title }}
              </div>
              <div v-if="index2 == 1" v-bind:class="item.sel2">
                {{ item2.item_title }}
              </div>
              <div v-if="index2 == 2" v-bind:class="item.sel3">
                {{ item2.item_title }}
              </div>
              <div v-if="index2 == 3" v-bind:class="item.sel4">
                {{ item2.item_title }}
              </div>
            </div>
          </div>
          <div
            class="comit"
            v-if="
              item.question_type == question_type.duoxuan &&
              item.result == null &&
              showType == '1'
            "
            @click="submit(item, index)"
          >
            <button>确认答案</button>
          </div>
          <!--          多选答案-->
          <div
            class="rightanswer"
            v-if="
              (showType == 2 ||
                (item.result == '2' || item.result == '1' &&
                  item.question_type == question_type.duoxuan)) &&
              item.danxuanAnswer == ''
            "
          >
            <div>答案：{{ item.duoxuanAnswer }}</div>
          </div>
          <!--          单选答案-->
          <div
            class="rightanswer"
            v-if="
              (showType == 2 ||
                (item.result == '2' || item.result == '1' &&
                  item.question_type != question_type.duoxuan)) &&
              item.duoxuanAnswer == ''
            "
          >
            <div>答案：{{ item.danxuanAnswer }}</div>
          </div>
          <div
            class="jiqiao"
            v-if="
              showType == 2 ||
              item.isshowanswer ||
              item.result == 2 ||
              item.result == 1
            "
          >
            <div class="title" v-show="licence_id != 5">
              <p></p>
              <div>本题技巧</div>
            </div>
            <div class="des this-qus" v-if="isvip">
              {{ item.skill }}
              <!-- <img src="../../../static/images/other-jiqiao.png" /> -->
            </div>
            <div class="des this-qus" v-else v-show="licence_id != 5">
              {{ item.skill.substr(0, 10) + `……` }}
              <span
                style="
                  float: right;
                  font-size: 0.12rem;
                  color: #fff;
                  background: #f64b4b;
                  padding: 0 0.1rem;
                  display: inline-block;
                  border-radius: 0.5rem;
                "
                @click="toVip"
                v-show="licence_id != 5"
                >查看完整技巧</span
              >
              <!-- <img src="../../../static/images/other-jiqiao.png" /> -->
            </div>
          </div>
          <div
            class="jiexi"
            v-if="
              showType == 2 ||
              item.isshowanswer ||
              item.result == '2' ||
              item.result == '1'
            "
          >
            <div class="title">
              <p></p>
              <div>官方解析</div>
            </div>
            <div class="des">{{ item.analysis }}</div>
          </div>
          <div
            class="nandu"
            v-if="
              showType == 2 ||
              item.isshowanswer ||
              item.result == '2' ||
              item.result == '1'
            "
          >
            难度
            <img
              v-bind:src="item.difficulty >= 0 ? xingimgUrl1 : xingimgUrl2"
            />
            <img
              v-bind:src="item.difficulty >= 1 ? xingimgUrl1 : xingimgUrl2"
            />
            <img
              v-bind:src="item.difficulty >= 2 ? xingimgUrl1 : xingimgUrl2"
            />
            <img
              v-bind:src="item.difficulty >= 3 ? xingimgUrl1 : xingimgUrl2"
            />
            <img
              v-bind:src="item.difficulty >= 4 ? xingimgUrl1 : xingimgUrl2"
            />
          </div>
        </div>
      </div>
      <div class="swiper-pagination" slot="pagination"></div>
    </Swiper>
    <div class="bottom">
      <div class="nexttab" v-show="!isallti && !isshow">
        <div class="swiper-button-next" @click="nextQuestion">下一题</div>
        <div class="swiper-button-prev" @click="upQuestion">上一题</div>
      </div>
      <div class="bot-info">
        <div class="tips">
          <div class="right">
            <img src="../../../static/images/other-right.png" />
            <p>{{ rightCount }}</p>
          </div>
          <div class="wrong">
            <img src="../../../static/images/other-wrong.png" />
            <!--            <p>{{ wrongquesidList.length }}</p>-->
            <p>{{ wrongCount }}</p>
          </div>
          <span
            @click="onreset"
            v-if="isallti"
            style="color: #666; margin-left: 0.2rem"
            >重新练习</span
          >
        </div>
        <div @click="tabshow" class="tab">
          <img src="../../../static/images/other-tab.png" />
          <p>{{ (currNowPage)>alltotal?alltotal:(currNowPage)}}/{{ alltotal }}</p>
        </div>
      </div>
      <div v-if="isallti" class="alltabs">
        <div v-for="(item, index) in list" :key="index">
          <p
            v-bind:class="[
              item.result == '1' ? 'right' : '',
              item.result == '2' ? 'wrong' : '',
              item.result == null ? '' : '',
            ]"
            @click="toeveryti(index, item)"
          >
            {{ index + 1 }}
          </p>
        </div>
      </div>
    </div>
    <!-- 放大图片弹窗 -->
    <div v-if="isshow" class="tip" @touchmove.prevent @click="closeImg">
      <img :src="getImgUrl(bigImgUrl)" />
    </div>
    <div v-if="isallti" class="mask"></div>
  </div>
</template>

<script>
import {
  addDid,
  delDid,
  // exercisePosition,
  getFine,
  isVip,
} from "../../api/sjlx";
import {
  addfavor,
  removefavor
} from "../../api/myfavor";
// import myMinix from '../mixin.js'
import {addWrong} from "@/api/wrong";
// import { getQuestionInfo } from "@/api/question";
// import { addWrong, removeWrong, getWrongList } from "@/api/wrong";
// import { addCollect, removeCollect, getCollectList } from "@/api/collect";
// import { randomCon } from "@/api/exam";
// // import { getUserId } from "@/utils/auth";
// import { checkSign } from "@/api/verify";
// import { getVip } from "@/api/pay";

let size = 50;
export default {
  beforeRouteEnter(to, form, next) {
    next();
  },
  beforeDestroy() {
    // this.exercisePosition(); //离开之前上报练习位置
  },
  name: "sjlx",
  data() {
    return {
      value1:false,
      azs: false,
      bzs: false,
      czs: false,
      dzs: false,
      //start---
      questionId: "", //练习的id
      question_no: "", //练习的题目序号
      result: {
        right: "1",
        error: "2",
      },
      list: [], //当前所有的题目
      question_type: {
        //题目类型
        danxuan: 1,
        duoxuan: 2,
        panduan: 3,
      },
      isCheck: false, //判断是否点击过
      rightCount: 0, //对的数量
      wrongCount: 0, //错的数量
      alltotal: 0, //题目总数

      //end---
      bigImgUrl: "",
      isLoading: false,
      xingimgUrl1: require("../../../static/images/other-hasnandu.png"),
      xingimgUrl2: require("../../../static/images/other-onnandu.png"),
      swiper2: null,
      showType: 1, //1-答题模式   2-背题模式
      currNowPage: 0, //当前在的页
      isvip: false, //是否是vip
      isallti: false,
      licence_id: 2, //车型
      kemuType: 1, //当前选择的科目
      isshow: false, //判断放大图片的样式是否展示
      swiperList: [], //在swiper中显示的题的数组
      isShowBack: false,
      // swiperOption: {
      //   slidesPerView: 1,
      //   //显示分页
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   nextButton: ".swiper-button-next",//绑定下一页的控制按钮
      //   prevButton: ".swiper-button-prev",//绑定上一页的控制按钮
      //
      //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
      //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
      //   loop: false,
      //   allowTouchMove: false
      // }
    };
  },
  // mixins:[myMinix],
  computed: {
    // 定义swiper，在下面就可以引用这个swiper了；
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
    watch:{
    list(v){
      console.log('变化了',v);
      this.value1 = true
    }
  },
  // beforeDestroy(){
  //   alert()
  //   console.log("beforeDestroy")
  // },
  created() {
    if (this.GetRequest("channel") == "exejH5") {
      this.isShowBack = true;
    }
    document.documentElement.style.fontSize = "625%";
    this.swiperOption = {
      // nextButton: ".swiper-button-next", //绑定下一页的控制按钮
      // prevButton: ".swiper-button-prev", //绑定上一页的控制按钮
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      loop: false,
      allowTouchMove: false,
      onInit: function (swiper) {
        this.swiper2 = swiper;
      },
      onSlideChangeStart: (swiper) => {
        console.log("onSlideChangeStart", swiper.realIndex);
        let item = this.swiperList[swiper.realIndex];
        console.log(item);
        let before = this.currNowPage;
        this.currNowPage = item.num;
        this.swiperChange(this.currNowPage, before);
        this.questionId = this.list[this.currNowPage - 1].question_id;
        console.log(this.questionId);
        this.question_no = swiper.activeIndex;
        console.log(this.question_no);
        // this.exercisePosition();
        this.scrollTop();
        // this.currNowPage = swiper.activeIndex;
        // this.currNowPage++
      },
      onSlideChangeEnd: (swiper) => {
        console.log("onSlideChangeEnd", swiper.realIndex);
        // let item = this.swiperList[swiper.realIndex];
        // console.log(item);
        // let before = this.currNowPage;
        // this.currNowPage = item.num;
        // this.swiperChange(this.currNowPage, before);
      },
    };
    this.licence_id =
      this.GetRequest("cx") == "xc"
        ? 2
        : this.GetRequest("cx") == "hc"
        ? 3
        : this.GetRequest("cx") == "kc"
        ? 4
        : this.GetRequest("cx") == "mtc"
        ? 5
        : 6;

    this.kemuType = this.GetRequest("km") == "kmy" ? 1 : 4;
  },

  mounted() {
    document.documentElement.style.fontSize = "625%";
    this.isVip();
    this.getFine();

    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
  },
  methods: {

        // 增加我的收藏 removefavor
    Addaddfavor(){
      addfavor({
        user_id:this.getUserId(),
        question_id:this.question_id
      }).then((res)=>{
        console.log('收藏结果',res);
        if(res.code === 0){
          console.log('收藏成功');
          let a = this.$message({
            dangerouslyUseHTMLString: true,
            message: "<strong>收藏成功</strong>",
            type: "none",
            center: true,
            duration: 0,
            offset:50,
            customClass:'customClass'
          });
          setTimeout(()=>{
            a.close()
          },1000)
          this.list[this.currNowPage -1].is_favor = 1
        }
      })
    },
        // 删除我的收藏 removefavor
    Removeremovefavor(){
      removefavor({
        user_id:this.getUserId(),
        question_id:this.question_id
      }).then((res)=>{
        console.log('删除收藏',res);
        if(res.code === 0){
           let a = this.$message({
            dangerouslyUseHTMLString: true,
            message: "<strong>删除收藏</strong>",
            type: "none",
            center: true,
            duration: 0,
            offset:50,
            customClass:'customClass'
          });
          setTimeout(()=>{
            a.close()
          },1000)
          this.list[this.currNowPage -1].is_favor = null
        }
      })
    },
    changeXing(){
      if(this.list[this.currNowPage -1].is_favor === null || this.list[this.currNowPage -1].is_favor === 0){
        this.Addaddfavor()
      }else{
        console.log('消除收藏');
        this.Removeremovefavor()
      }
    },

        qiehuanmoshi2(type) {
      this.showType = type;
      if (type == 1) {
        this.list.forEach((k) => {
          k.sel1 = null;
          k.sel2 = null;
          k.sel3 = null;
          k.sel4 = null;
          if (k.result != null) {
            let list = k.answer.split(",");
            for (let i = 0; i < list.length; i++) {
              if (list[i] == "1") {
                k.sel1 = "selectright";
              } else if (list[i] == "2") {
                k.sel2 = "selectright";
              } else if (list[i] == "3") {
                k.sel3 = "selectright";
              } else {
                k.sel4 = "selectright";
              }
            }
            if (
              k.result == this.result.error &&
              this.list[this.currNowPage - 1].question_type !== 2
            ) {
              if (k.user_answer == "0") {
                k.sel1 = "selectwrong";
              }
              if (k.user_answer == "1") {
                k.sel2 = "selectwrong";
              }
              if (k.user_answer == "2") {
                k.sel3 = "selectwrong";
              }
              if (k.user_answer == "3") {
                k.sel4 = "selectwrong";
              }
            } else {
              if (k.user_answer == "0") {
                k.sel3 = "selectwrong";
                k.sel4 = "selectwrong";
              }
              if (k.user_answer == "1") {
                k.sel2 = "selectwrong";
                k.sel4 = "selectwrong";
              }
              if (k.user_answer == "2") {
                k.sel2 = "selectwrong";
                k.sel3 = "selectwrong";
              }
              if (k.user_answer == "3") {
                k.sel1 = "selectwrong";
                k.sel4 = "selectwrong";
              }
              if (k.user_answer == "4") {
                k.sel1 = "selectwrong";
                k.sel3 = "selectwrong";
              }
              if (k.user_answer == "5") {
                k.sel1 = "selectwrong";
                k.sel2 = "selectwrong";
              }
              if (k.user_answer == "6") {
                k.sel4 = "selectwrong";
              }
              if (k.user_answer == "7") {
                k.sel3 = "selectwrong";
              }
              if (k.user_answer == "8") {
                k.sel2 = "selectwrong";
              }
              if (k.user_answer == "9") {
                k.sel1 = "selectwrong";
              }
            }
          }
        });
        this.toeveryti(this.currNowPage - 1, this.list[this.currNowPage - 1]);
      }
      if (type == 2) {
        this.list.forEach((item) => {
          item.sel1 = null;
          item.sel2 = null;
          item.sel3 = null;
          item.sel4 = null;
          let list = item.answer.split(",");
          for (let i = 0; i < list.length; i++) {
            if (list[i] == "1") {
              item.sel1 = "selectright";
              this.$set(item, "sel1", "selectright");
            } else if (list[i] == "2") {
              item.sel2 = "selectright";
              this.$set(item, "sel2", "selectright");
            } else if (list[i] == "3") {
              item.sel3 = "selectright";
              this.$set(item, "sel3", "selectright");
            } else {
              item.sel4 = "selectright";
              this.$set(item, "sel4", "selectright");
            }
          }
        });
        this.toeveryti(this.currNowPage - 1, this.list[this.currNowPage - 1]);
        this.azs = false;
        this.bzs = false;
        this.czs = false;
        this.dzs = false;
      }
    },
    //确认答案
    submit(item, index) {
      console.log(item.userObj);
      let newArr = Object.values(item.userObj);
      newArr = newArr.filter((v) => {
        return v && v.trim();
      });
      newArr = newArr.toString();
      console.log(newArr);
      console.log(item.answer.split(","));
      console.log(typeof item.answer.split(",")[0]);
      // console.log(newArr);
      // console.log(item.answer);
      // console.log(newArr===item.answer);
      // console.log(item);
      // let rightlist = item.answer.split(",").sort(); //当前题目的正确选项
      // console.log(rightlist);
      // let userDuoXuanAsswer = item.userDuoXuanAsswer.sort(); //当前用户选择的选项list
      if (newArr === item.answer) {
        item.result = this.result.right;
        this.list[item.num - 1].result = 1;
        this.list[item.num - 1].user_answer = "10";
        item.result = this.result.right;
        this.rightCount++;
        this.nextQuestion();
        // this.swiper.slideTo(index + 1, 500, false); //选对自动滑动到下一页
        // this.currNowPage = this.currNowPage + 1;
      } else {
        this.wrongCount++;
        item.result = this.result.error;
        // item.result = 2;
        this.list[item.num - 1].result = 2;
        let arrZs = Object.values(item.userObj);
        console.log("zssz", arrZs);

        if ("1,2" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectwrong");
          this.$set(item, "sel4", "selectwrong");
          this.list[item.num - 1].user_answer = "0";
        } else if ("1,3" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectwrong");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectwrong");
          this.list[item.num - 1].user_answer = "1";
        } else if ("1,4" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectwrong");
          this.$set(item, "sel3", "selectwrong");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "2";
        } else if ("2,3" === item.answer) {
          this.$set(item, "sel1", "selectwrong");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectwrong");
          this.list[item.num - 1].user_answer = "3";
        } else if ("2,4" === item.answer) {
          this.$set(item, "sel1", "selectwrong");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectwrong");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "4";
        } else if ("3,4" === item.answer) {
          this.$set(item, "sel1", "selectwrong");
          this.$set(item, "sel2", "selectwrong");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "5";
        } else if ("1,2,3" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectwrong");
          this.list[item.num - 1].user_answer = "6";
        } else if ("1,2,4" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectwrong");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "7";
        } else if ("1,3,4" === item.answer) {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectwrong");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "8";
        } else if ("2,3,4" === item.answer) {
          this.$set(item, "sel1", "selectwrong");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectright");
          this.list[item.num - 1].user_answer = "9";
        } else {
          this.$set(item, "sel1", "selectright");
          this.$set(item, "sel2", "selectright");
          this.$set(item, "sel3", "selectright");
          this.$set(item, "sel4", "selectright");
        }
      }
      // this.list[item.num - 1].result = item.result;
      // console.log('张石啊提交以后看看',item.question_id, item.result, this.list[item.num - 1].user_answer, item.chapter_id);
      // this.addDid(
      //   item.question_id,
      //   item.result,
      //   this.list[item.num - 1].user_answer,
      //   item.chapter_id
      // ); //  上报答题
      this.addWrongPage(item.question_id); //上报错题记录
      this.azs = false;
      this.bzs = false;
      this.czs = false;
      this.dzs = false;
    },
    //选择答案
    selectanswer2(item, index, idx1) {
      this.questionId = item.question_id; //记录练习问题id
      this.question_no = idx1 + 1; //记录练习序号
      // console.log(idx1);
      // console.log(item.num);
      // console.log(item);
      // console.log("zzt", this.questionId);
      // console.log("zzz1", this.question_no);
      // console.log("所以题目", this.list);
      // console.log("page", this.currNowPage);
      if (item.question_type == this.question_type.duoxuan) {
        // console.log('张石啊',item.question_id, item.result, index, item.chapter_id);
        if (this.list[item.num - 1].result === null && this.showType === 1) {
          // console.log(this.azs);
          if (index == 0) {
            this.azs = !this.azs;
            this.$set(item, "sel1", this.azs === true ? "selectright" : null);
            // this.azs === true ? item.sel1="selectright": item.sel1=null
          }
          if (index == 1) {
            this.bzs = !this.bzs;
            this.$set(item, "sel2", this.bzs === true ? "selectright" : null);
            // this.azs === true ? item.sel2="selectright": item.sel2=null
          }
          if (index == 2) {
            this.czs = !this.czs;
            this.$set(item, "sel3", this.czs === true ? "selectright" : null);
            // this.azs === true ? item.sel3="selectright": item.sel3=null
          }
          if (index == 3) {
            this.dzs = !this.dzs;
            this.$set(item, "sel4", this.dzs === true ? "selectright" : null);
            // this.azs === true ? item.sel4="selectright": item.sel4=null
          }
        }
        console.log("结果：", item.answer);
        console.log("azs", this.azs);
        console.log(item);
        console.log("swiperList", this.swiperList[item.num - 1]);

        if (item.answer.split(",").includes((index + 1).toString())) {
          //存在
          if (index == 0) {
            this.$set(item.userObj, "sel1", this.azs === true ? "1" : "");
            // item.userObj.sel1 = "selectright";
          }
          if (index == 1) {
            this.$set(item.userObj, "sel2", this.bzs === true ? "2" : "");
            // item.userObj.sel2 = "selectright";
          }
          if (index == 2) {
            // item.userObj.sel3 = "selectright";
            this.$set(item.userObj, "sel3", this.czs === true ? "3" : "");
          }
          if (index == 3) {
            // item.userObj.sel4 = "selectright";
            this.$set(item.userObj, "sel4", this.dzs === true ? "4" : "");
          }
        } else {
          //不存在
          if (index == 0) {
            this.$set(
              item.userObj,
              "sel1",
              this.azs === true ? "selectwrong" : null
            );
          }
          if (index == 1) {
            this.$set(
              item.userObj,
              "sel2",
              this.bzs === true ? "selectwrong" : null
            );
          }
          if (index == 2) {
            this.$set(
              item.userObj,
              "sel3",
              this.czs === true ? "selectwrong" : null
            );
          }
          if (index == 3) {
            this.$set(
              item.userObj,
              "sel4",
              this.dzs === true ? "selectwrong" : null
            );
            // item.userObj.sel4 = "selectwrong";
          }
        }
        console.log(index);
      } else {
        console.log("单选和判断");
        if (
          item.sel3 != null ||
          item.sel1 != null ||
          item.sel2 != null ||
          item.sel4 != null
        ) {
          //答过题的不可作答
          return;
        }
        //  选择完去匹配答案是否正确
        if (index + 1 == item.answer) {
          //当前点击的这项等于答案
          item.result = this.result.right;
          if (index == 0) {
            this.$set(item, "sel1", "selectright");
            this.list[this.currNowPage - 1].sel1 = "selectright";
            // this.list[this.currNowPage - 1].user_answer = "0";
          }
          if (index == 1) {
            this.$set(item, "sel2", "selectright");
            this.list[this.currNowPage - 1].sel2 = "selectright";
            // this.list[this.currNowPage - 1].user_answer = "1";
          }
          if (index == 2) {
            this.$set(item, "sel3", "selectright");
            this.list[this.currNowPage - 1].sel3 = "selectright";
            // this.list[this.currNowPage - 1].user_answer = "2";
          }
          if (index == 3) {
            this.$set(item, "sel4", "selectright");
            this.list[this.currNowPage - 1].sel4 = "selectright";
            // this.list[this.currNowPage - 1].user_answer = "3";
          }
          this.rightCount++;
          // this.$set(item, "result", "1");
          this.list[item.num - 1].result = 1;
          // this.swiper.slideTo(idx1 + 1, 500, false); //选对自动滑动到下一页
          // this.addWrongPage(item.question_id);
          this.nextQuestion();
          // this.currNowPage = item.num; //当前问题序号
          // this.question_id = item.question_id;
          // this.addDid(item.question_id, item.result, index, item.chapter_id); //  上报答题
          // this.list[idx1].result = item.result;
          // this.makeSwiperList()
          // this.getFine()
        } else {
          // item.result = this.result.error;
          // this.$set(item, "result", "2");

          item.isshowanswer = true;
          // this.list[idx1].result = item.result;
          this.list[item.num - 1].result = 2;
          item.result = 2;
          if (index == 0) {
            this.$set(item, "sel1", "selectwrong");
            // this.list[this.currNowPage-1].sel1 = "selectwrong"
            this.list[this.currNowPage - 1].user_answer = "0";
          }
          if (index == 1) {
            this.$set(item, "sel2", "selectwrong");
            // this.list[this.currNowPage-1].sel2 = "selectwrong"
            this.list[this.currNowPage - 1].user_answer = "1";
          }
          if (index == 2) {
            this.$set(item, "sel3", "selectwrong");
            // this.list[this.currNowPage-1].sel3 = "selectwrong"
            this.list[this.currNowPage - 1].user_answer = "2";
          }
          if (index == 3) {
            this.$set(item, "sel4", "selectwrong");
            // this.list[this.currNowPage-1].sel4 = "selectwrong"
            this.list[this.currNowPage - 1].user_answer = "3";
          }
          var ss = item.answer.split(",");
          for (var i = 0; i < ss.length; i++) {
            var sss = ss[i];
            if (sss == "1") {
              item.sel1 = "selectright";
              this.$set(item, "sel1", "selectright");
            } else if (sss == "2") {
              item.sel2 = "selectright";
            } else if (sss == "3") {
              item.sel3 = "selectright";
            } else {
              item.sel4 = "selectright";
            }
          }
          this.wrongCount++;
          this.addWrongPage(item.question_id); //上报错题记录
          // console.log('index',index);
          // this.makeSwiperList()
          // this.getFine()
        }
        // this.addDid(
        //   item.question_id,
        //   this.list[item.num - 1].result,
        //   this.list[item.num - 1].user_answer,
        //   item.chapter_id
        // ); //  上报答题
      }
    },
    swiperChange(n, o) {
      console.log("swiperChange", n, o);
      if (n > o) {
        this.nextQuestion();
      } else {
        this.upQuestion();
      }
    },
    //上报错题
    addWrongPage(question_id) {
      addWrong({
        user_id: this.GetRequest("userid"),
        question_id: question_id
      })
    },
    nextQuestion() {
      // console.log(this.question_id)
      // return
      let i = this.swiperList.findIndex((item) => {
        return item.question_id == this.question_id;
      });

      // console.log(this.list.at(-1).question_id,this.question_id)
      if (this.list[this.list.length - 1].question_id == this.question_id) {
        this.$dialog.alert({
          message: "已经是最后了",
        });
        return false;
      }
      // console.log(this.swiperList.length - i)
      let index = Math.floor(this.currNowPage / size) + 1;
      if (this.swiperList.length - i < 10 && index <= this.twoList.length - 1) {
        this.swiperList.push(...this.twoList[index]);
        this.$nextTick(() => {
          this.nextQuestion();
        });
        this.questionId = this.list[index].question_id;
        this.question_no = index;
        // this.exercisePosition();
      } else {
        // this.currNowPage++;
        this.question_id = this.swiperList[i + 1].question_id;
        this.currNowPage = this.swiperList[i + 1].num;
        this.swiper.slideTo(i + 1, 200, false);
        this.questionId = this.swiperList[i + 1].question_id;
        this.question_no = index;
        // this.exercisePosition();
      }
      this.scrollTop();
    },
    upQuestion() {
      let i = this.swiperList.findIndex((item) => {
        return item.question_id == this.question_id;
      });
      console.log("upQuestion", i);
      if (this.list[0].question_id === this.question_id) {
        this.$dialog.alert({
          message: "已经是第一题了",
        });
        return false;
      }
      let index = Math.floor(this.currNowPage / size) - 1;
      if (i < 10 && index >= 0) {
        this.swiperList.unshift(...this.twoList[index]);
        this.$nextTick(() => {
          this.upQuestion();
        });
        this.questionId = this.list[index].question_id;
        this.question_no = index;
        // this.exercisePosition();
      } else {
        this.question_id = this.swiperList[i - 1].question_id;
        this.currNowPage = this.swiperList[i - 1].num;
        console.log(this.swiperList[i]);
        this.swiper.slideTo(i - 1, 200, false);
        this.questionId = this.swiperList[i - 1].question_id;
        this.question_no = index;
        // this.exercisePosition();
      }
      this.scrollTop();
    },
    // goBack(){
    //   alert('999')
    // },
    //start---------------------------------------------------------------------
    onreset() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定清除记录重新开始吗？",
        })
        .then(() => {
          // on close
          delDid({
            appid: this.GetRequest("appid"),
            user_id: this.GetRequest("userid"),
            licence_id: this.licence_id, //小车C1:2
            subject_id: this.kemuType, //科目一：1
            origin: 1, //1顺序练习和章节练习；3精简题库
            chapters_id: -1, //章节id，精简题库传-1，此处顺序练习也要传，与上报练习位置不同
          }).then((res) => {
            console.log(res);
            if (res.code == 0) {
              // this.swiper.slideTo(0, 0, false); //回到起始页
              this.getFine();
              this.rightCount = 0;
              this.wrongCount = 0;
              // this.currNowPage = 0;
              this.$toast.success({ duration: 3, message: "清除成功" });
              this.isallti = false;
            }else{
              this.$toast({ icon:'error',duration: 3000, message: "清除失败,点击重试" });
            }
          });
        })
        .catch(() => {
          this.isallti = false;
        });
    },

    // exercisePosition() {
    //   //上报练习位置
    //   // alert(1)
    //   exercisePosition({
    //     licence_id: this.licence_id, //小车C1:2
    //     subject_id: this.kemuType, //科目一：1
    //     appid: this.GetRequest("appid"),
    //     user_id: this.GetRequest("userid"),
    //     question_id: this.questionId,
    //     question_no: this.question_no,
    //     origin: 1, //1顺序练习和章节练习；3精简题库
    //     chapters_id: -1, //章节id，精简题库传-1，此处顺序练习也要传，与上报练习位置不同
    //   }).then((res) => {
    //     console.log(res);
    //   });
    // },
    //确认答案
    // qiehuanmoshi2(type) {
    //   this.showType = type;
    //   if (type == 1) {
    //     this.list.forEach((k) => {
    //       k.sel1 = null;
    //       k.sel2 = null;
    //       k.sel3 = null;
    //       k.sel4 = null;
    //       if (k.result != null) {
    //         let list = k.answer.split(",");
    //         for (let i = 0; i < list.length; i++) {
    //           if (list[i] == "1") {
    //             k.sel1 = "selectright";
    //           } else if (list[i] == "2") {
    //             k.sel2 = "selectright";
    //           } else if (list[i] == "3") {
    //             k.sel3 = "selectright";
    //           } else {
    //             k.sel4 = "selectright";
    //           }
    //         }
    //         if (
    //           k.result == this.result.error &&
    //           this.list[this.currNowPage - 1].question_type !== 2
    //         ) {
    //           if (k.user_answer == "0") {
    //             k.sel1 = "selectwrong";
    //           }
    //           if (k.user_answer == "1") {
    //             k.sel2 = "selectwrong";
    //           }
    //           if (k.user_answer == "2") {
    //             k.sel3 = "selectwrong";
    //           }
    //           if (k.user_answer == "3") {
    //             k.sel4 = "selectwrong";
    //           }
    //         } else {
    //           if (k.user_answer == "0") {
    //             k.sel3 = "selectwrong";
    //             k.sel4 = "selectwrong";
    //           }
    //           if (k.user_answer == "1") {
    //             k.sel2 = "selectwrong";
    //             k.sel4 = "selectwrong";
    //           }
    //           if (k.user_answer == "2") {
    //             k.sel2 = "selectwrong";
    //             k.sel3 = "selectwrong";
    //           }
    //           if (k.user_answer == "3") {
    //             k.sel1 = "selectwrong";
    //             k.sel4 = "selectwrong";
    //           }
    //           if (k.user_answer == "4") {
    //             k.sel1 = "selectwrong";
    //             k.sel3 = "selectwrong";
    //           }
    //           if (k.user_answer == "5") {
    //             k.sel1 = "selectwrong";
    //             k.sel2 = "selectwrong";
    //           }
    //           if (k.user_answer == "6") {
    //             k.sel4 = "selectwrong";
    //           }
    //           if (k.user_answer == "7") {
    //             k.sel3 = "selectwrong";
    //           }
    //           if (k.user_answer == "8") {
    //             k.sel2 = "selectwrong";
    //           }
    //           if (k.user_answer == "9") {
    //             k.sel1 = "selectwrong";
    //           }
    //         }
    //       }
    //     });
    //     this.toeveryti(this.currNowPage - 1, this.list[this.currNowPage - 1]);
    //   }
    //   if (type == 2) {
    //     this.list.forEach((item) => {
    //       item.sel1 = null;
    //       item.sel2 = null;
    //       item.sel3 = null;
    //       item.sel4 = null;
    //       let list = item.answer.split(",");
    //       for (let i = 0; i < list.length; i++) {
    //         if (list[i] == "1") {
    //           item.sel1 = "selectright";
    //           this.$set(item, "sel1", "selectright");
    //         } else if (list[i] == "2") {
    //           item.sel2 = "selectright";
    //           this.$set(item, "sel2", "selectright");
    //         } else if (list[i] == "3") {
    //           item.sel3 = "selectright";
    //           this.$set(item, "sel3", "selectright");
    //         } else {
    //           item.sel4 = "selectright";
    //           this.$set(item, "sel4", "selectright");
    //         }
    //       }
    //     });
    //     this.toeveryti(this.currNowPage - 1, this.list[this.currNowPage - 1]);
    //     this.azs = false;
    //     this.bzs = false;
    //     this.czs = false;
    //     this.dzs = false;
    //   }
    // },
    
    //确认答案
              getFine() {
            // alert(1111)
            // console.time("111");
            // alert(this.GetRequest("appid"))
            // this.$loading.show()
            // this.$loading('正在加载中...');
            const loading = this.$loading({ 
                lock: true,
                text: '题库加载中',
                // spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.9)',
                customClass:'#cnnd'
              });
            getFine({
              licence_id: this.licence_id, //小车C1:2
              subject_id: this.kemuType, //科目一：1 科目四：4
              appid: this.GetRequest("appid"),
              user_id: this.getUserId(),
            }).then((res) => {
              console.log("结果", res);
              // res.data.list.length = 100
              res.data.list.forEach((k, index) => {
                k.num = index + 1;
                k.duoxuanAnswer = ""; //存储多选的答案
                k.danxuanAnswer = ""; //存储多选的答案
                k.userDuoXuanAsswer = []; //存储用户点击的选项
                k.isshowanswer = false; //判断是否展示确认答案（一期代码）
                k.userObj = {
                  sel1: null,
                  sel2: null,
                  sel3: null,
                  sel4: null,
                };
                k.sel1 = null; //是否选择了a
                k.sel2 = null; //是否选择了b
                k.sel3 = null; //是否选择了c
                k.sel4 = null; //是否选择了d
                // k.items = JSON.parse(k.items);
                if (k.question_type == 2) {
                  //多选
                  k.answer.split(",").forEach((i) => {
                    if (i == 1) {
                      k.duoxuanAnswer += "A";
                    }
                    if (i == 2) {
                      k.duoxuanAnswer += "B";
                    }
                    if (i == 3) {
                      k.duoxuanAnswer += "C";
                    }
                    if (i == 4) {
                      k.duoxuanAnswer += "D";
                    }
                  });
                } else {
                  //单选
                  if (k.answer == 1) {
                    k.danxuanAnswer = "A";
                  }
                  if (k.answer == 2) {
                    k.danxuanAnswer = "B";
                  }
                  if (k.answer == 3) {
                    k.danxuanAnswer = "C";
                  }
                  if (k.answer == 4) {
                    k.danxuanAnswer = "D";
                  }
                }
      
                //判断是否答过题
                if (k.result != null) {
                  if (k.answer == "1") {
                    k.sel1 = "selectright";
                  }
                  if (k.answer == "2") {
                    k.sel2 = "selectright";
                  }
                  if (k.answer == "3") {
                    k.sel3 = "selectright";
                  }
                  if (k.answer == "4") {
                    k.sel4 = "selectright";
                  }
                  if (k.result == this.result.right) {
                    this.rightCount++;
                  }
                  if (k.result == this.result.error) {
                    this.wrongCount++;
                    if (k.user_answer == "0") {
                      k.sel1 = "selectwrong";
                    }
                    if (k.user_answer == "1") {
                      k.sel2 = "selectwrong";
                    }
                    if (k.user_answer == "2") {
                      k.sel3 = "selectwrong";
                    }
                    if (k.user_answer == "3") {
                      k.sel4 = "selectwrong";
                    }
                  }
                }
              });
              res.data.list.forEach((item) => {
                if (item.question_type == 2) {
                  if (item.result == 1) {
                    if ("1,2" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                    } else if ("1,3" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel3 = "selectright";
                    } else if ("1,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("2,3" === item.answer) {
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                    } else if ("2,4" === item.answer) {
                      item.sel2 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("3,4" === item.answer) {
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("1,2,3" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                    } else if ("1,2,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("1,3,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("2,3,4" === item.answer) {
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    } else {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    }
                  } else if (item.result == 2) {
                    if ("1,2" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel3 = "selectwrong";
                      item.sel4 = "selectwrong";
                    } else if ("1,3" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectwrong";
                      item.sel3 = "selectright";
                      item.sel4 = "selectwrong";
                    } else if ("1,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectwrong";
                      item.sel3 = "selectwrong";
                      item.sel4 = "selectright";
                    } else if ("2,3" === item.answer) {
                      item.sel1 = "selectwrong";
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectwrong";
                    } else if ("2,4" === item.answer) {
                      item.sel1 = "selectwrong";
                      item.sel2 = "selectright";
                      item.sel3 = "selectwrong";
                      item.sel4 = "selectright";
                    } else if ("3,4" === item.answer) {
                      item.sel1 = "selectwrong";
                      item.sel2 = "selectwrong";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("1,2,3" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectwrong";
                    } else if ("1,2,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectright";
                      item.sel3 = "selectwrong";
                      item.sel4 = "selectright";
                    } else if ("1,3,4" === item.answer) {
                      item.sel1 = "selectright";
                      item.sel2 = "selectwrong";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    } else if ("2,3,4" === item.answer) {
                      item.sel1 = "selectwrong";
                      item.sel2 = "selectright";
                      item.sel3 = "selectright";
                      item.sel4 = "selectright";
                    }
                  } else {
                    item.sel1 = null;
                    item.sel2 = null;
                    item.sel3 = null;
                    item.sel4 = null;
                  }
                }
              });
              let that = this;
              this.$nextTick(() => {
                //显示上次答题的位置
                // console.timeEnd("111");
                console.log("渲染完成");
      
                // that.currNowPage = 360;
                that.question_id =
                  res.data?.position?.question_id || res.data.list[0].question_id; //根据index取question_id
      
                that.list.find(({ question_id }) => question_id == that.question_id)=== undefined
            ? (this.currNowPage = 1)
            : (this.currNowPage = that.list.find(
                ({ question_id }) => question_id == that.question_id
              ).num);
                // if (res.data.position != null) {
                //   if (res.data.position.question_no) {
                //     // this.swiper.slideTo(res.data.position.question_no, 0, false);
                //     // this.currNowPage = res.data.position.question_no;
                //     // this.question_id = res.data.position.question_id;
                //     that.currNowPage = 0;
                //     that.question_id = 520;
                //     console.log(that)
                //   }
                // }
                this.makeSwiperList();
                
              });
              this.alltotal = res.data.total;
              this.list = res.data.list; //.filter(item => item.question_type == '2')
              // this.swiperList[30].sel1 = "selectright";
              console.log(this.list);
              // this.$loading.close();
              loading.close()
            });
          },
    //返回页面顶部
    scrollTop() {
      if (window.top == window.self) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      } else {
        window.parent.document.scrollTop =
          window.parent.document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    makeSwiperList() {
      let twoList = []; //二维数组;
      let total = Math.ceil(this.list.length / size);
      console.log(total);
      for (let i = 0; i < total; i++) {
        let list = this.list.slice(size * i, (i + 1) * size);
        // console.log("-------", list);
        // console.log(twoList);
        twoList.push(list);
      }
      this.twoList = JSON.parse(JSON.stringify(twoList));
      // console.log(twoList);
      let swiperIndex = Math.floor(this.currNowPage / size);
      // console.log(swiperIndex, this.currNowPage % size);
      let tl = JSON.parse(JSON.stringify(this.twoList));
      if (this.twoList.length == swiperIndex) {
        swiperIndex = swiperIndex - 1;
      }
      let slist = tl[swiperIndex];
      console.log("swiperIndex", swiperIndex);
      if (swiperIndex != 0) {
        console.log("执行了wiperIndex != 0");
        let tl = JSON.parse(JSON.stringify(this.twoList));
        slist.unshift(...tl[swiperIndex - 1]);
      }
      if (swiperIndex != total - 1) {
        console.log("不是最后");
        let tl = JSON.parse(JSON.stringify(this.twoList));
        console.log("tl", tl, tl[swiperIndex + 1]);
        slist.push(...tl[swiperIndex + 1]);
      }
      this.swiperList = slist;
      let i = slist.findIndex((item) => {
        return item.question_id == this.question_id;
      });
      // console.log("iiii",i)
      // console.log(this.currNowPage % size)
      this.swiper.slideTo(i, 200, false);
      console.log("slist", slist);
    },
    //判断是否是vip
    isVip() {
      isVip({
        appid: this.GetRequest("appid"),
        userid: this.GetRequest("userid"),
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.isvip = true;
        } else {
          this.isvip = false;
        }
      });
    },
    //放大图片
    bigImg(url) {
      this.bigImgUrl = url;
      this.isshow = true;
    },
    closeImg() {
      this.isshow = false;
    },
    //点击题目序号
    toeveryti(index, item) {
      this.question_id = item.question_id;
      this.currNowPage = this.list.find(
        ({ question_id }) => question_id == this.question_id
      ).num;
      this.questionId = item.question_id;
      this.question_no = index;
      // this.exercisePosition();
      this.makeSwiperList();
      // console.log(this.alltotal[index]);
      // this.swiper.slideTo(index, 500, false);
      // this.currNowPage = this.swiper.activeIndex;
      this.isallti = false;
      this.scrollTop();
      this.azs = false;
      this.bzs = false;
      this.czs = false;
      this.dzs = false;
    },
    //上报已做习题（新）
    addDid(questionId, result, user_answer, chapter_id) {
      addDid({
        licence_id: this.licence_id, //小车C1:2
        subject_id: this.kemuType, //科目一：1
        appid: this.GetRequest("appid"),
        user_id: this.GetRequest("userid"),
        question_id: questionId,
        origin: 1, //1顺序练习和章节练习；3精简题库
        result: result,
        user_answer: user_answer,
        chapters_id: chapter_id, //章节id，精简题库传-1，此处顺序练习也要传，与上报练习位置不同
      }).then((res) => {
        console.log(res);
      });
    },
    //end-------------------------------------------------------------------
    toVip() {
      this.$router.push({
        name: "vipindex",
        query: {
          userid: this.GetRequest("userid"),
          km: this.GetRequest("km"),
          cx: this.GetRequest("cx"),
          appid: this.GetRequest("appid"),
          appver: this.GetRequest("appver"),
          channel: this.GetRequest("channel"),
          os: this.GetRequest("os"),
          timestamp: this.GetRequest("timestamp"),
          sign: this.GetRequest("sign"),
          schoolid: this.GetRequest("schoolid")
            ? this.GetRequest("schoolid")
            : "",
          coachid: this.GetRequest("coachid") ? this.GetRequest("coachid") : "",
        },
      });
    },
    getUserId() {
      return this.GetRequest("userid");
    },
    GetRequest(value) {
      return this.$route.query[value];
    },
    getImgUrl(icon) {
      //获取图片地址
      if (icon) {
        let img = this.GlobalUrl + icon;
        return img;
      }
    },
    tabshow() {
      this.$data.isallti = !this.$data.isallti;
    },
    back() {
      this.$router.go(-1); //返回上一层
    },
  },
  afterDestory() {
    document.documentElement.style.fontSize = "";
  },
};
</script>
<style>
.customClass{
  min-width: 60px !important;
  text-align: center !important;
 
}
 .el-message__content{
   text-align: center !important;
   padding: auto !important;
   margin-left: -10px !important;
 }
 .el-message.is-center {
    justify-content: center !important;
     margin-left: -10px !important;
}
</style>
<style lang="scss" scoped>
/deep/ .van-toast--loading {
  opacity: 0;
}

/deep/ .van-overlay {
  opacity: 0;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  width: 0.88rem;
  background-image: url(../../../static/images/other-next.png);

  background-size: cover;
  background-color: #fff;
  border: 0px;
  margin-top: -14px;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  width: 0.88rem;
  background-image: url(../../../static/images/other-next.png);

  background-size: cover;
  background-color: #fff;
  border: 0px;
  margin-top: -14px;
}

.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 112;
}

.container {
  width: 100%;
  font-size: 0.18rem;
  color: #333333;
  padding-bottom: 1.4rem;
  background: #ffffff;

  .tip {
    position: fixed;
    width: 100%;
    height: 100%;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
    align-items: center;
    z-index: 222;
    justify-content: center;
    display: flex;

    img {
      width: 99%;
      display: block;
      margin: auto;
    }
  }

  .lianxi-bot-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  .lianxidati-hege {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;

    .bg {
      margin: 0 auto;
      width: 2.7rem;
      height: 3.25rem;
      background-color: rgba(255, 255, 255, 1);
      margin-top: 1.7rem;
      border-radius: 3px;
      text-align: center;
      position: relative;

      .circle {
        width: 1.14rem;
        position: absolute;
        top: 0.4rem;
        left: 50%;
        right: 0;
        margin-left: -0.56rem;

        .title {
          color: #fff;
        }
      }

      .shengyu {
        position: absolute;
        top: 0.76rem;
        color: rgba(51, 51, 51, 1);
        font-size: 0.16rem;
        width: 2rem;
        left: 50%;
        margin-left: -1rem;
      }

      .tishu {
        color: rgba(51, 197, 0, 1);
        font-size: 0.16rem;
        width: 2rem;
        position: absolute;
        top: 1.02rem;
        left: 50%;
        margin-left: -1rem;
      }

      .defen {
        color: rgba(51, 51, 51, 1);
        font-size: 0.16rem;
        width: 2rem;
        position: absolute;
        top: 1.94rem;
        left: 50%;
        margin-left: -1rem;
        letter-spacing: 1px;
      }

      .btn {
        position: absolute;
        top: 2.6rem;
        width: 2.4rem;
        left: 50%;
        margin-left: -1.2rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.39rem;

        button {
          height: 0.4rem;
          font-size: 0.16rem;
          width: 100%;
          border-radius: 2px;
          background-color: rgba(0, 145, 255, 1);
          color: #fff;
          border: 0;
        }
      }
    }
  }

  .lianxidati-buhege {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;

    .bg {
      margin: 0 auto;
      width: 2.7rem;
      height: 3.25rem;
      background-color: rgba(255, 255, 255, 1);
      margin-top: 1.7rem;
      border-radius: 3px;
      text-align: center;
      position: relative;

      .atitle {
        color: rgba(249, 83, 0, 1);
        font-size: 0.2rem;
        top: -3rem;
        position: absolute;
        left: 0;
        right: 0;
      }

      .circle {
        
        width: 1.12rem;
        position: absolute;
        top: 0.8rem;
        left: 50%;
        right: 0;
        margin-left: -0.56rem;

        .title {
          color: #fff;
        }
      }

      .shengyu {
        position: absolute;
        top: 1.17rem;
        color: rgba(51, 51, 51, 1);
        font-size: 0.16rem;
        width: 2rem;
        left: 50%;
        margin-left: -1rem;
      }

      .tishu {
        color: rgba(249, 83, 0, 1);
        font-size: 0.16rem;
        width: 2rem;
        position: absolute;
        top: 1.42rem;
        left: 50%;
        margin-left: -1rem;
      }

      .defen {
        color: rgba(51, 51, 51, 1);
        font-size: 0.16rem;
        width: 2rem;
        position: absolute;
        top: 2.15rem;
        left: 50%;
        margin-left: -1rem;
        letter-spacing: 1px;
      }

      .btn {
        position: absolute;
        top: 2.6rem;
        width: 2.4rem;
        left: 50%;
        margin-left: -1.2rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.39rem;

        button {
          height: 0.4rem;
          font-size: 0.16rem;
          width: 1.1rem;
          border: 1px solid rgba(102, 102, 102, 1);
          background-color: #fff;
          border-radius: 2px;
        }

        button:nth-child(2) {
          background-color: rgba(0, 145, 255, 1);
          color: #fff;
          border: 0;
        }
      }
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    /* margin-left: 6%; */
    /* margin-right: 4%; */
    width: 100%;
    padding-top: 0.15rem;
    position: fixed;
    z-index: 111;
    background: #ffffff;

    .fanhui {
      //position: absolute;
      top: 0.2rem;
      left: 0.23rem;
      width: 0.09rem;
      //height: 0.18rem;
      img {
        position: absolute;
        top: 25px;
        left: 13px;
        width: 3%;
        height: 33%;
      }
    }

    .fankui {
      margin-top: 0.1rem;
      font-size: 0.15rem;
      letter-spacing: 0.01rem;
    }

    .tab {
      margin-top: 0.05rem;
      font-size: 0.16rem;
      display: flex;
      font-size: 0.16rem;
      height: 0.29rem;
      line-height: 0.29rem;

      div {
        padding-left: 0.1rem;
        padding-right: 0.1rem;
        color: #0090ff;
        border: 1px solid #0090ff;
      }

      div:nth-child(1) {
        border-radius: 3px 0 0 3px;
      }

      div:nth-child(2) {
        border-radius: 0px 3px 3px 0px;
      }

      .select {
        color: #ffffff;
        background-color: #0090ff;
      }
    }
  }

  .ad {
    margin-top: 0.12rem;
    width: 100%;
    height: 0.63rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bottom {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 0.14rem;
    z-index: 222;

    .bot-info {
      background-color: #fff;
      bottom: 0;
      //display: flex;
      height: 0.46rem;
      width: 100%;
      font-size: 0.14rem;
      border-top: 1px solid #dcdcdc;
      position: relative;

      p {
        margin: 0;
        padding: 0;
      }

      .collect {
        display: flex;
        position: absolute;
        width: 1rem;
        height: 0.4rem;
        bottom: 0.05rem;

        img {
          width: 0.13rem;
          height: 0.13rem;
          position: absolute;
          left: 0.2rem;
          top: 0.15rem;
        }

        p {
          position: absolute;
          color: #333;
          font-weight: bold;
          left: 0.4rem;
          top: 0.12rem;
          width: 0.5rem;
        }
      }

      .tips {
        display: flex;
        position: relative;
        margin: 0 auto;
        margin-top: 0.16rem;
        vertical-align: middle;
        line-height: 0.14rem;

        img {
          width: 0.13rem;
          height: 0.13rem;
          margin-left: 0.2rem;
        }

        div {
          display: flex;

          p {
            margin-left: 0.05rem;
          }
        }

        div:nth-child(1) {
          color: #51bb2a;
        }

        div:nth-child(2) {
          color: #eb3838;
        }
      }

      .tab {
        //display: flex;
        //position: relative;

        img {
          position: absolute;
          width: 0.13rem;
          height: 0.13rem;
          top: 0.16rem;
          right: 0.9rem;
        }

        p {
          position: absolute;
          top: 0.15rem;
          right: 0.2rem;
          font-weight: bold;
          color: #333333;
        }
      }
    }

    .nexttab {
      bottom: 0.05rem;
      display: flex;
      width: 2.5rem;
      left: 0;
      right: 0;
      height: 0.5rem;
      justify-content: space-between;
      margin: 0 auto;
      color: #333333;
      font-size: 0.13rem;
      line-height: 0.5rem;
      position: relative;

      div {
        width: 0.88rem;
        background-image: url(../../../static/images/other-next.png);
        background-size: cover;
        background-color: #fff;
        border: 0px;
        text-align: center;
      }

      button {
        width: 0.88rem;
        background-image: url(../../../static/images/other-next.png);
        background-size: cover;
        background-color: #fff;
        border: 0px;
      }

      .no {
        color: #999999;
        background-image: url(../../../static/images/other-next-no.png);
      }
    }

    .alltabs {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      height: 2rem;
      overflow-y: scroll;
      border-top: 1px solid #dcdcdc;

      padding-top: 0.1rem;

      div {
        width: 20%;
        height: 0.5rem;
        line-height: 0.4rem;
        text-align: center;

        p {
          border-radius: 50%;
          border: 1px solid #0090ff;
          width: 0.4rem;
          height: 0.4rem;
          padding: 0;
          margin: 0;
          margin: 0 auto;
        }
      }

      .right {
        background-color: #e0fdeb;
        border: 1px solid #33c500;
        color: #33c500;
      }

      .wrong {
        background-color: #ffddde;
        border: 1px solid #fe5b5b;
        color: #fe3a3a;
      }
    }
  }

  .beiti {
    width: 100%;
    color: #333333;
    font-size: 0.17rem;
    margin-top: 0.15rem;
    width: 94%;
    margin-left: 3%;

    .title {
      display: flex;
    }

    .tips {
      position: relative;
      margin-top: 0.02rem;

      img {
        width: 0.38rem;
        height: 0.19rem;
        position: absolute;
        top: 0.02rem;
        left: 0rem;
      }

      div {
        color: #fff;
        font-size: 0.12rem;
        position: absolute;
        top: 0.03rem;
        left: 0.06rem;
        width: 0.38rem;
      }
    }

    .info {
      letter-spacing: 2px;
      line-height: 0.3rem;
      text-indent: 0.44rem;
      width: 100%;
    }

    .pic {
      width: 100%;
      text-align: center;

      // height: 1.25rem;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 200px;
      }
    }

    .rightanswer {
      height: 0.53rem;
      width: 100%;
      background-color: #f5f5f5;
      margin-top: 0.1rem;

      div {
        color: #333333;
        font-size: 0.17rem;
        font-weight: bold;
        line-height: 0.53rem;
        margin-left: 0.16rem;
      }
    }

    .selecttab {
      margin-top: 0.06rem;

      .item {
        margin-top: 0.06rem;
        display: flex;
        position: relative;

        div:nth-child(1) {
          background-image: url(../../../static/images/other-daanbg.png);
          background-size: cover;
          height: 0.46rem;
          width: 0.46rem;
          text-align: center;
          line-height: 0.46rem;
          // color: #333;
        }

        div:nth-child(2) {
          margin: 0;
          padding: 0;
          margin-top: 0.1rem;
          margin-left: 0.17rem;
          // text-indent: 0.4rem;
          line-height: 0.25rem;
          width: 2.8rem;
        }

        .selectright {
          color: #33c500;
        }

        .selectwrong {
          color: #eb3838;
        }

        .thisselect {
          color: #0090ff;
        }
      }

      .select {
        div:nth-child(1) {
          background-image: url(../../../static/images/other-daanselected.png);
          color: #fff;
        }

        div:nth-child(2) {
          color: #0090ff;
        }
      }
    }

    .comit {
      bottom: 1.1rem;
      height: 0.5rem;
      width: 80%;
      margin-left: 10%;
      margin-top: 0.1rem;

      button {
        border: 0px;
        width: 100%;
        height: 100%;
        background-image: url(../../../static/images/other-comitbg.png);
        background-size: 100% 100%;
        background-color: #fff;
        color: #fff;
        font-size: 0.17rem;
        margin: 0 auto;
      }
    }

    .jiqiao {
      margin-top: 0.29rem;
      margin-bottom: 0.25rem;

      .title {
        p {
          margin: 0;
          padding: 0;
          width: 0.03rem;
          height: 0.14rem;
          background-color: #0091ff;
        }

        div {
          margin-left: 0.08rem;
          color: #333;
          font-size: 0.15rem;
          line-height: 0.15rem;
        }
      }

      .des {
        line-height: 0.25rem;
        margin-top: 0.2rem;
        color: #333;
        font-size: 0.16rem;
      }
    }

    .jiexi {
      margin-top: 0.29rem;
      margin-bottom: 0.25rem;

      .title {
        p {
          margin: 0;
          padding: 0;
          width: 0.03rem;
          height: 0.14rem;
          background-color: #0091ff;
        }

        div {
          margin-left: 0.08rem;
          color: #333;
          font-size: 0.15rem;
          line-height: 0.15rem;
        }
      }

      .des {
        line-height: 0.25rem;
        margin-top: 0.2rem;
        color: #333;
        font-size: 0.16rem;
      }
    }

    .nandu {
      margin-right: 0.11rem;
      margin-left: 0.14rem;
      font-size: 0.17rem;

      img {
        margin-left: 0.03rem;
        width: 0.15rem;
        height: 0.14rem;
      }
    }
  }
}
</style>
